// Authentication and session types
import { User, Company } from './user';

export interface AuthSession {
  token: string;
  refreshToken: string;
  user: User;
  company: Company;
  expiresAt: Date;
  issuedAt: Date;
}

export interface LoginCredentials {
  email: string;
  password: string;
  rememberMe?: boolean;
  twoFactorCode?: string;
}

export interface RegistrationData {
  // Company info
  companyName: string;
  nip: string;
  address: string;
  industry: string;
  
  // Admin user info
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  confirmPassword: string;
  
  // Terms and privacy
  acceptTerms: boolean;
  acceptPrivacy: boolean;
  marketingConsent?: boolean;
}

export interface PasswordReset {
  email: string;
  token?: string;
  newPassword?: string;
  confirmPassword?: string;
}

export interface TwoFactorAuth {
  isEnabled: boolean;
  secret?: string;
  backupCodes: string[];
  lastUsedAt?: Date;
}

export enum AuthStatus {
  PENDING_VERIFICATION = 'pending_verification',
  ACTIVE = 'active',
  SUSPENDED = 'suspended',
  LOCKED = 'locked'
}

export interface AuthContextType {
  // State
  isAuthenticated: boolean;
  isLoading: boolean;
  user: User | null;
  session: AuthSession | null;
  error: string | null;

  // Actions
  login: (credentials: LoginCredentials) => Promise<void>;
  logout: () => void;
  register: (data: RegistrationData) => Promise<void>;
  resetPassword: (email: string) => Promise<void>;
  verifyEmail: (token: string) => Promise<void>;
  refreshSession: () => Promise<void>;
  clearError: () => void;
}